import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 24 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const PageHero = ({ chip, title, subtitle, image, children, testid }) => (
  <section className="relative rs-radial text-[#0A192F] overflow-hidden" data-testid={testid}>
    {image && <img src={image} alt="" className="absolute inset-0 w-full h-full object-cover opacity-30" />}
    <div className="absolute inset-0 bg-gradient-to-r from-[#E8F0FE] via-[#E8F0FE]/85 to-[#E8F0FE]/30" />
    <div className="absolute inset-0 rs-grid-bg opacity-60" />
    <div className="relative max-w-7xl mx-auto px-5 lg:px-8 py-20 lg:py-28">
      <Reveal>
        {chip && <span className="rs-chip">{chip}</span>}
        <h1 className="mt-5 text-4xl sm:text-5xl lg:text-6xl font-extrabold max-w-3xl leading-[1.15]">{title}</h1>
        {subtitle && <p className="mt-5 text-base md:text-lg text-slate-600 max-w-2xl">{subtitle}</p>}
        {children}
      </Reveal>
    </div>
  </section>
);
